import {makeStyles} from '@material-ui/core/styles'
import TableGridDiv from '../../2compounds/Tables/TableGridDiv'
import TableHeaderRow from '../../2compounds/Tables/TableHeaderRow'
import TableHeaderCell from '../../2compounds/Tables/TableHeaderCell'
import TableBody from '../../2compounds/Tables/TableBody'
import TableBodyRow from '../../2compounds/Tables/TableBodyRow'
import TableBodyCell from '../../2compounds/Tables/TableBodyCell'
import React from 'react'
import {Text} from '../../1elements'

const GeneralGuidelinesTable = () => {
    const classes = useStyles()
    const columns = [
        {label: 'If you want to...', position: 'span 4'},
        {label: 'Follow these guidelines', position: 'span 8'},
    ]

    const generalGuidelinesList = [
        {title: 'Enter values that include commas',
            body: 'Multiple values can be entered in a column, separated by a comma.'},
        {title: 'Upload non-ASCII or double-byte data',
            body: 'Be sure to save the CSV file in UTF-8, so the information is readable.'},
        {title: 'Add/ delete columns.',
            body: 'You can enter information only in the columns available in the downloaded file. You can\'t add/delete ' +
                'columns. The system will reject a file if additional or fewer columns are detected.'},
        {title: 'Update existing data records',
            body: [<u>DO NOT use this sheet to UPDATE THE EXISTING DATA RECORD.</u>, <br/>,
                'This file only adds new data records. Any update/edit tasks are to be done in the system through the function of in-situ update.']},
        {title: 'Skip downloading template',
            body: 'The system does not allow you to skip the step of template download. It ensures that you always have ' +
                'the latest version and a blank template to enter information.'},
    ]

    return (
        <>
            <Text type={'bulkImportRuleHeader3'}>General Guidelines</Text>
            <TableGridDiv className={classes.root}>
                {/*  Table Header  */}
                <TableHeaderRow>
                    {columns.map((column)=>(
                        <TableHeaderCell gridColumn={column.position}
                                         key={column.label}
                                         label={column.label}  />
                    ))}
                </TableHeaderRow>
                {/*  Table Body  */}
                <TableBody className={classes.tableBody}>
                    {generalGuidelinesList.map((generalGuideline, index) => {
                        const {title, body} = generalGuideline
                        return(
                            <TableBodyRow isOpen={true} key={index} className={classes.tableRow} >
                                <TableBodyCell gridColumn={columns[0].position} className={classes.tableCell} fontSize={'14px'}>
                                    <b>{title}</b>
                                </TableBodyCell>
                                <TableBodyCell gridColumn={columns[1].position} className={classes.tableCell} fontSize={'14px'}>
                                    {body}
                                </TableBodyCell>
                            </TableBodyRow>
                        )})}
                </TableBody>

            </TableGridDiv>
        </>
    )
}

export default GeneralGuidelinesTable

const useStyles = makeStyles({
    tableCell: {
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'clip'
    },
    tableBody: {
        maxHeight: '130px'
    },
    tableRow: {
        height: '130px'
    },
})